import React, { useState, useEffect, useRef } from "react";
import { throttle } from "lodash";
import { useAppSelector, useAppDispatch } from "../redux/hooks";
import { toggleChatTray, renderHtmlInTray } from "../redux/chatbotSlice";
import { getPlatform, isOnMobile } from "../helper/BrowserHelper";

const ChatHeader: React.FC = () => {
  const [splashSvgIconContainerWidth, setSplashSvgIconContainerWidth] =
    useState(0);
  const { chatMessage, isChatTrayOpen, showBotHeader } = useAppSelector(
    (state) => state.chatbot
  );
  const hideSplashScreenInApp = chatMessage.length > 1 && !showBotHeader;
  const splashSvgIconContainerRef = useRef<HTMLDivElement | null>(null);

  const dispatch = useAppDispatch();

  //Added below function to make svg responsive
  const onWindowResize = throttle(() => {
    if (splashSvgIconContainerRef.current) {
      setSplashSvgIconContainerWidth(
        splashSvgIconContainerRef.current.clientHeight
      );
    }
  }, 50);

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    onWindowResize();

    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  });

  const renderTrayToggleButton = () => {
    if (!isChatTrayOpen) {
      return (
        <div
          className={`${
            isOnMobile() || getPlatform() === "App"
              ? "chat-header-tray-toggle-mobile"
              : "chat-header-tray-toggle"
          }`}
          onClick={handleTrayToggleAction}
        >
          &lt; 条款与条件
        </div>
      );
    }
  };

  const handleCloseButtonClick = () => {
    // notify parent window to close the chatbot iframe
    if (window.parent) {
      window.parent.postMessage({ action: 'closeMandarinChatbot' }, '*');
    }
  };

  const renderCloseButton = () => {
    if (isOnMobile() && getPlatform() !== "App") {
      return (
        <div
          onClick={handleCloseButtonClick}
          className="chat-header-close-mobile"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            className="icon icon-large chat-close-icon"
          >
            <use xlinkHref="#icon-close" />
          </svg>
        </div>
      );
    }
  };

  const renderSplashScreen = () => {
    return (
      <div className="chat-splash-screen">
        <div
          className="icon-container"
          ref={splashSvgIconContainerRef}
          key="icon-container"
          style={{ width: splashSvgIconContainerWidth }}
        >
          <span className="splash-text">需要帮助吗？</span>
        </div>
      </div>
    );
  };

  const handleTrayToggleAction = () => {
    if (isChatTrayOpen === false) {
      dispatch(toggleChatTray(true));
    } else {
      dispatch(toggleChatTray(false));
      dispatch(
        renderHtmlInTray({
          isRenderHtmlInTray: false,
        })
      );
    }
  };

  return chatMessage.length < 1 ? (
    <div
      className={`${"chat-header"} ${
        hideSplashScreenInApp ? "hide-element" : ""
      } ${isChatTrayOpen ? "chat-tray-open-header" : ""}`}
    >
      <div className="chat-title-container">
        <div className="screen-title-wrapper">{renderSplashScreen()}</div>
      </div>
    </div>
  ) : (
    <div
      className={`${"chat-header-background"} ${
        hideSplashScreenInApp ? "hide-element" : ""
      } ${isChatTrayOpen ? "chat-tray-open-header" : ""}`}
    >
      {renderTrayToggleButton()}
      {renderCloseButton()}
      <p
        className={`${
          isOnMobile() || getPlatform() === "App"
            ? "ask-hana-mobile"
            : "ask-hana"
        }`}
      >
        需要帮助吗？
      </p>
    </div>
  );
};

export default ChatHeader;
